import { render, staticRenderFns } from "./RemoveProfile.vue?vue&type=template&id=11b828d1"
import script from "./RemoveProfile.vue?vue&type=script&lang=js"
export * from "./RemoveProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports